import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 25 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#333",
      stroke: "#333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m17.064 11.16-4.517-8.17a.972.972 0 0 1-.022-.876.8.8 0 0 1 .274-.326.7.7 0 0 1 .38-.121h4.562c.253 0 .501.074.722.215s.408.344.543.59l4.3 7.768c.153.277.234.598.234.926s-.081.65-.234.927l-4.3 7.768a1.6 1.6 0 0 1-.543.59c-.221.14-.47.215-.722.215H13.18a.7.7 0 0 1-.382-.12.8.8 0 0 1-.275-.328.97.97 0 0 1 .024-.878zM5.67 11.16 1.153 2.994a.971.971 0 0 1-.024-.879.8.8 0 0 1 .275-.327.7.7 0 0 1 .382-.12h4.56c.253 0 .501.074.723.215.221.14.408.344.543.59l4.3 7.768c.153.277.234.598.234.926s-.081.65-.234.927l-4.3 7.768c-.135.246-.322.45-.543.59a1.35 1.35 0 0 1-.723.215h-4.56a.7.7 0 0 1-.382-.12.8.8 0 0 1-.275-.328.97.97 0 0 1 .024-.878z"
    }, null, -1)
  ])))
}
export default { render: render }